import { WZUtils } from '../../../../common/globals'
// import {getServerTime} from '../../../../utils/base'

import { text2time, prop } from '../../../../utils/base'

export default {
  beginTime(state) {
    const { baseConf } = state
    if (baseConf && baseConf.begin) {
      return text2time(baseConf.begin)
    }
    return 0
  },
  endTime(state) {
    const { baseConf } = state
    if (baseConf && baseConf.end) {
      return text2time(baseConf.end)
    }
    return 0
  },


  // 最新发布的 XSApp
  latestXSApp(state) {
    return WZUtils.isInXSApp() ? state._latestAppInfo : null
  },

  // 是否为将要发布的 XSApp
  isNextXSApp(_state, getters) {
    const version = prop(getters.latestXSApp, 'version')
    if (version && WZUtils.isInXSApp()) {
      return WZUtils.diffWZAppVersion(version) > 0
    }
    return false
  },

  // 是否需要检测 XSApp 信息
  needCheckXSApp(_state, getters) {
    const { latestXSApp, isNextXSApp } = getters

    // 非玄商APP OR 非IOS端，不检测
    if (!WZUtils.isInXSApp() || !WZUtils.isInIOS()) {
      return false
    }

    // 本地无缓存
    if (!latestXSApp || !latestXSApp.version) {
      return true
    }

    // 当前为审核中的版本，检测
    if (isNextXSApp) {
      // if (_latestAppInfo && _latestAppInfo.mtime > 0) {
      //   const expTime = getServerTime() + _expMinutes * 60000
      //   if (_latestAppInfo.mtime < expTime) {
      //     // 1 小时内已更新过，不再请求
      //     return false
      //   }
      // }
      return true
    }

    return false
  },

  // 主页 pageKey
  homePageKey(_state, getters) {
    return WZUtils.isInIOS() && getters.isNextXSApp
      ? 'ios.xsHome'
      : 'web.xsHome'
  }
}
